import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {PipesModule} from '../../pipes/pipes.module';
import {Evaluation360ReportModule} from '../full-reports/360-evaluation/360-evaluation-report.module';
import {FreeEvaluationReportModule} from '../full-reports/free-evaluation/free-evaluation-report.module';
import {ReviewEvaluationsModal} from './review-evaluations.modal';

@NgModule({
    declarations: [
        ReviewEvaluationsModal
    ],
    imports: [
        CommonModule,
        IonicModule,
        PipesModule,
        Evaluation360ReportModule,
        FreeEvaluationReportModule
    ],
    exports: [
        ReviewEvaluationsModal
    ]
})
export class ReviewEvaluationsModule {
}
